import { render, staticRenderFns } from "./functionalArea.vue?vue&type=template&id=273ee6ee&scoped=true&"
import script from "./functionalArea.vue?vue&type=script&lang=js&"
export * from "./functionalArea.vue?vue&type=script&lang=js&"
import style0 from "./functionalArea.vue?vue&type=style&index=0&id=273ee6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ee6ee",
  null
  
)

export default component.exports